/**
 * База URL для REST (без завершающего /).
 * Приоритет: window / meta (прод, правка без пересборки) → REACT_APP_API_URL → эвристики по location.
 */
function readRuntimeApiBaseFromWindow() {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.__API_BASE_URL__;
    if (typeof raw === 'string' && raw.trim()) {
      return raw.trim().replace(/\/$/, '');
    }
    const meta = typeof document !== 'undefined' ? document.querySelector('meta[name="api-base-url"]') : null;
    const c = meta && meta.getAttribute('content');
    if (c && String(c).trim()) {
      return String(c).trim().replace(/\/$/, '');
    }
  } catch (e) {
    /* ignore */
  }
  return null;
}

// Хелпер для получения базового URL API
export const getApiBaseURL = () => {
  const runtimeBase = readRuntimeApiBaseFromWindow();
  if (runtimeBase) return runtimeBase;

  if (process.env.REACT_APP_API_URL) {
    const url = process.env.REACT_APP_API_URL.trim();
    return url.endsWith('/') ? url.slice(0, -1) : url;
  }

  if (typeof window !== 'undefined' && window.location && window.location.origin) {
    const origin = window.location.origin;
    const port = window.location.port;
    // В dev CRA/craco проксирует /api, /uploads, /socket.io на backend (см. craco.config.js).
    // Пустая база = относительные URL → прокси; прямой :5000 обходит прокси и ломается, если API другой хост/не запущен.
    if (
      process.env.NODE_ENV === 'development' &&
      (port === '3001' || port === '3000')
    ) {
      return '';
    }
    // Сборка на 3001/3000 без dev (редко): как раньше — тот же хост, порт API
    if (origin.includes(':3001') || origin.includes(':3000')) {
      return origin.replace(/:\d+$/, ':5000');
    }
    // Production: тот же origin (Express отдаёт и статику, и /api)
    return origin;
  }
  // SSR или fallback: в development предполагаем сервер на 5000
  if (typeof process !== 'undefined' && process.env.NODE_ENV === 'development') {
    return 'http://localhost:5000';
  }
  return '';
};

/**
 * Разбор тела ответа fetch как JSON; если пришла HTML-страница (404/index.html), даём понятную ошибку.
 * @param {Response} res
 * @returns {Promise<unknown>}
 */
export async function parseFetchJsonResponse(res) {
  const text = await res.text();
  const trimmed = text.trim();
  if (!trimmed) {
    throw new Error(`Пустой ответ сервера (HTTP ${res.status})`);
  }
  if (trimmed.startsWith('<')) {
    throw new Error(
      'Сервер вернул HTML вместо JSON (часто это index.html): API недоступен по текущему адресу. ' +
        'В production соберите фронт с REACT_APP_API_URL=https://ваш-сервер-API (без / в конце) ' +
        'или перед загрузкой скриптов задайте window.__API_BASE_URL__ или meta name="api-base-url" в index.html; ' +
        'убедитесь, что nginx/IIS проксирует /api на Node.'
    );
  }
  try {
    return JSON.parse(text);
  } catch (e) {
    throw new Error(`Ответ не JSON (HTTP ${res.status}): ${e.message}`);
  }
}

